import React from "react";

import { SERVICE_TYPE } from "@typings/globals";

import { useFeatureToggle } from "@hooks/useFeatureToggle";
import { useConfig } from "@hooks/useConfig";

import { Carousel } from "@www/src/static_pages/components/Carousel";

import { BusinessCleaning } from "./BusinessCleaning";
import { EotCleaning } from "./EotCleaning";
import { HomeCleaning } from "./HomeCleaning";
import { CleaningProducts } from "./CleaningProducts";
import * as Styled from "./ServiceList.styled";

export const ServicesList = () => {
  const availableServices = useConfig<SERVICE_TYPE[]>(["availableServices"]);
  const isCleaningProductsAvailable = useFeatureToggle(
    "cleaning_products_sale",
  );

  const isHomeCleaningAvailable = availableServices.includes(
    SERVICE_TYPE.HOME_CLEANING,
  );
  const isEotCleaningAvailable = availableServices.includes(
    SERVICE_TYPE.END_OF_TENANCY,
  );
  const isBusinessCleaningAvailable = availableServices.includes(
    SERVICE_TYPE.B2B,
  );

  const services = [
    {
      component: (
        <HomeCleaning
          key="home-cleaning"
          isComingSoon={!isHomeCleaningAvailable}
        />
      ),
      isComingSoon: !isHomeCleaningAvailable,
    },
    {
      component: (
        <EotCleaning
          key="eot-cleaning"
          isComingSoon={!isEotCleaningAvailable}
        />
      ),
      isComingSoon: !isEotCleaningAvailable,
    },
    {
      component: (
        <BusinessCleaning
          key="b2b-cleaning"
          isComingSoon={!isBusinessCleaningAvailable}
        />
      ),
      isComingSoon: !isBusinessCleaningAvailable,
    },
    {
      component: (
        <CleaningProducts
          key="cleaning-products"
          isComingSoon={!isCleaningProductsAvailable}
        />
      ),
      isComingSoon: !isCleaningProductsAvailable,
    },
  ]
    .sort((a, b) => {
      if (a.isComingSoon === b.isComingSoon) return 0;
      return a.isComingSoon ? 1 : -1;
    })
    .map(({ component }) => component);

  return (
    <React.Fragment>
      <Styled.OnlyMobile>
        <Carousel>{services}</Carousel>
      </Styled.OnlyMobile>
      <Styled.SmallTabletList>{services}</Styled.SmallTabletList>
    </React.Fragment>
  );
};
